import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function ChangeOrderBackButton() {

	const navigate = useNavigate();
	let [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const { order } = useContext(RetailOrderContext);

	return (
		<Button
			elementAttr={{ 'data-testid': 'btn-back' }}
			text="Back"
			icon="Inscyth-Back"
			onClick={() =>
				navigate(`/cfi/retail-order/${order.details.retailOrderID}/120` + (!!returnUrl ? '?returnUrl=' + returnUrl : ''))
			} >
		</Button>
	)
}
